import { render, staticRenderFns } from "./AddPannel.vue?vue&type=template&id=2d63255e&scoped=true"
import script from "./AddPannel.vue?vue&type=script&lang=js"
export * from "./AddPannel.vue?vue&type=script&lang=js"
import style0 from "./AddPannel.vue?vue&type=style&index=0&id=2d63255e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d63255e",
  null
  
)

export default component.exports